export const MENU_DELAY = 0.1;
export const STAGGER_CHILDREN_DURATION = 0.15;
